import useTable from "@organisms/Table/Table.context"
import ViewBar from "@organisms/ViewBar/ViewBar"

import { TableViewPhaseProps } from "./TableViewPhase.types"

export default function TableViewPhase(props: TableViewPhaseProps) {
    const { phase, title } = props

    const { setActivePhase, activePhase } = useTable()

    return <ViewBar.Phase phase={phase} title={title} activePhase={activePhase} onPhaseChange={setActivePhase} />
}
